  /*============Brand Bar Controller
  ================================*/
  angular
      .module('vppApp')
      .controller('contentAccordionController', contentAccordionController);

    contentAccordionController.$inject = ['$rootScope', '$scope', '$window','contentAccordionFactory', '$stateParams', 'vppConfig', '$timeout', 'apiFactory'];

    function contentAccordionController(rootScope, $scope, $window, contentAccordionFactory, $stateParams, vppConfig, $timeout, apiFactory){
      var ao = getParameterByName('ao');
      var views = document.querySelectorAll('[data-ui-view]');
      for(var i = 0; i < views.length; i++){
        if(views[i].dataset.uiView === 'row-three'){
          var rowThree = views[i];
          rowThree.style.visibility = 'visible';
        }
      }

      // sectionThree.style.visibility = 'visible'

      $scope.expandCallback = function (index, id) {
        console.log('expand:', index, id);
      };

      $scope.collapseCallback = function (index, id) {
        console.log('collapse:', index, id);
      };

      $scope.goToForgotPasswordUrl = function () {
        apiFactory.getForgotPasswordURL($scope.siteCode, 'english').then(function (response) {
            $window.location.href = response.data;
        })
      };

        $scope.$on('accordion:onReady', function () {
          if(ao){
            $timeout(function() {
            var accordions = $scope.accordions;
             for (var key in accordions) {
              var currentAcc = accordions[key];
              if(currentAcc.id === ao){
                var paneId = currentAcc.id;
                var paneClass = document.getElementById(ao).getElementsByClassName('v-pane-content')[0];
                $scope.accordion.expand(currentAcc.id);
                paneClass.style.maxHeight = 'none';
              }
             }
            }, 1000);
           }
        });

      contentAccordionFactory().then(function (response) {
        $scope.accordions = response.data.faqs.accordions;
        $scope.heading = response.data.faqs.heading;
        $scope.subHeading = response.data.faqs.subHeading;
        $scope.iAmClass = response.data.faqs.iAmClass;
        $scope.iAmSubClass = response.data.faqs.iAmSubClass;
        $scope.iAmId = response.data.faqs.iAmId;
        $scope.fileSrc = $scope.accordions[0].fileSrc;
        $scope.title = $scope.accordions[0].title;
        $scope.controllerAbbr = $scope.accordions[0].controllerAbbr;

      });
  }